import React from "react"
import { Helmet } from "react-helmet"

import "bootstrap/dist/css/bootstrap.min.css"

import Dashboard from "../components/Dashboard.js"

import { MuiPickersUtilsProvider } from "@material-ui/pickers"
import DateFnsUtils from "@date-io/date-fns"

import "../styles/styles.css"

const IndexPage = () => (
  <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Plano SP Status</title>
          </Helmet>
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <div className="boardContainer">
        <Dashboard />
      </div>
    </MuiPickersUtilsProvider>
  </div>
)

export default IndexPage
